import React, { useId } from 'react';

interface SwitchProps {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label?: string;
    disabled?: boolean;
    size?: 'sm' | 'md';
    className?: string;
}

const NativeInput = 'input';

export const Switch: React.FC<SwitchProps> = ({
    checked,
    onChange,
    label,
    disabled = false,
    size = 'md',
    className = ''
}) => {
    const generatedId = useId();
    const inputId = generatedId;
    const sizeClasses = {
        sm: {
            switch: 'w-8 h-4',
            dot: 'w-3 h-3',
            translate: 'translate-x-4'
        },
        md: {
            switch: 'w-11 h-6',
            dot: 'w-4 h-4',
            translate: 'translate-x-5'
        }
    };

    return (
        <div className={`group inline-flex items-center ${disabled ? 'cursor-not-allowed opacity-60' : 'cursor-pointer'} ${className}`}>
            <label htmlFor={inputId} className="relative block">
                <NativeInput
                    id={inputId}
                    type="checkbox"
                    role="switch"
                    className="peer sr-only"
                    checked={checked}
                    onChange={(e) => !disabled && onChange(e.target.checked)}
                    disabled={disabled}
                />
                <span
                    aria-hidden="true"
                    className={`rounded-full bg-gray-200 transition-colors duration-200 ease-in-out peer-checked:bg-primary peer-focus:ring-2 peer-focus:ring-primary peer-focus:ring-offset-1 dark:bg-gray-700 dark:peer-focus:ring-offset-gray-900 ${sizeClasses[size].switch}
                    ${disabled ? 'opacity-60' : ''}
                `}
                />
                <span
                    aria-hidden="true"
                    className={`absolute top-[2px] left-[2px] translate-x-0 transform rounded-full border border-gray-300 bg-white shadow-sm transition-all duration-200 ease-in-out dark:border-gray-600 ${sizeClasses[size].dot}
                    ${size === 'sm' ? 'peer-checked:translate-x-4' : 'peer-checked:translate-x-5'} peer-checked:border-white`}
                />
            </label>
            {label ? <label htmlFor={inputId} className={`ml-3 font-medium text-sm ${disabled ? 'text-gray-400' : 'text-gray-900 dark:text-gray-300'}`}>
                    {label}
                </label> : null}
        </div>
    );
};













